import * as React from "react";
import { useEffect, useState } from "react";
import { groupBy, isNumber } from "lodash";
import { PaymentType } from "../../../../../../../../../Wrap/Constants/Enums/Apply/PaymentType";
import { ProductOverviewPaymentsInAction } from "../../Action/ProductOverviewPaymentsInAction";
import { ClientAccount } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { Table } from "../../../../../../../../Shared/Table/Table";
import { PaymentPayer } from "../../../../../../../../../Wrap/Constants/Enums/Payments/PaymentPayer";
import AriaTooltip from "../../../../../../../../Shared/Tooltip/AriaTooltip";
import { EscalationBasisMap, PaymentPayerMapper, TransferStatusMapper, TransferTypeMapper } from "../../Constant/Content";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { JsonDateParser } from "../../../../../../../../../react-core/Utils/JsonDateParser";
import { Lightbox, LightboxType } from "../../../../../../../../../react-core/Html/Components/Lightbox";
import { SubAccountType } from "../../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../../../../Common/Helpers/SubAccountTypeHelper";
import { Action } from "../../../../../../../Actions/Action";
import { CashPaymentTypeQuery } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { CashPaymentFrequencyQuery } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { CashPayment } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { PaymentSource } from "../../../../../../../../../Wrap/Constants/Enums/Domain/PaymentSource";
import { PaymentStatus } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { InstructionType } from "../../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { StaticUrls } from "../../../../../../../Resoures/StaticUrls";
import { SelectRegularPaymentPop } from "../../../Common/SelectRegularPaymentPop";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../../../../Shared/Permission/PermissionHelper";
import { Permission } from "../../../../../../../../Shared/Permission/Permission";
import { MpaaInfoModel } from "../../../../../../../../../Wrap/Models/Models/Payments/MPAA/MpaaInfoModel";
import { Indexation } from "../../../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/Indexation";
import { IndexationMap } from "../../../../../RegularPaymentWizard/Resource/Contents";
import { IndexationType } from "../../../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";
import { PaymentSubType } from "../../../../../../../../../Wrap/Constants/Enums/Apply/PaymentSubType";

interface IActiveInstructionsProps {
    subAccountHierarchyId: string;
    activeTransferIn: any;
    SubaccountType?: SubAccountType;
    headAccount: ClientAccount;
}

const splitData = (data) => {
    const result = { single: null, regular: null, transferIn: null };
    const filteredData = data.filter(item => item.Payer !== PaymentPayer.NotSpecified && item.PaymentSubType !== PaymentSubType.TransferIn);
    const groupedData = groupBy(filteredData, "Type");
    Object.keys(groupedData).forEach((key) => {
        if (key === PaymentType.Single.toString()) {
            result.single = groupedData[key];
        } else if (key === PaymentType.Regular.toString()) {
            result.regular = groupedData[key];
        }
    });
    return result;
};

export const ActiveInstructions = (props: IActiveInstructionsProps) => {
    const [regularPayment, setRegularPayment] = useState(null);
    const [singlePayment, setSinglePayment] = useState(null);
    const [activeTransfersIn, setactiveTransfersIn] = useState(null);
    const [selectClientRegular, setSelectClientRegular] = useState<CashPayment[]>([]);
    const [lightBoxInfo, setLightBoxInfo] = useState({
        isShow: false,
        amount: null,
        frequency: null,
        bankAccount: null,
        nextPaymentDate: null,
        cashEntryId: null,
    });
    const [showMPAAValue, setShowMPAAValue] = useState(false);
    const [mpaaInfo, setMPAAInfo] = useState<MpaaInfoModel>(null);
    const [indexation, setIndexationState] = useState<Indexation[]>([]);

    const editRegularLink = (cashEntryId: number) => {
        return StaticUrls.RegularPaymentUrl(
            props.SubaccountType.toString(),
            props.headAccount?.HeadClAccountId,
            props.headAccount?.HierarchyId,
            props.subAccountHierarchyId,
            "edit",
            cashEntryId
        );
    };

    const isNpr = props.SubaccountType === SubAccountType.Npr || props.SubaccountType === SubAccountType.JuniorSipp;

    const renderRegularPayments = () => {
        // add the indexation column as it is not in the regularPayment data structure
        const paymentsHtml: JSX.Element[] = [];
        Object.keys(regularPayment).forEach(key => {
            regularPayment[key].Indexation = "No Indexation"; // default
            indexation.forEach((indexationDetails) => {
                if (indexationDetails.CashEntryId == regularPayment[key].CashEntryId) {
                    regularPayment[key].Indexation =
                        (indexationDetails.IndexationType == IndexationType.FixedPercentage ? indexationDetails.Percentage + "%" : IndexationMap[IndexationType.AverageWeeklyEarning])
                        + " | " + JsonDateParser.getFormatDate(indexationDetails.EffectiveDate, "dd/MM/yyyy");
                }
            });
        });

        paymentsHtml.push(
            <div className="panel-subtle pt-0 pb-10 mb-40">
                <Table
                    cssWrapper="table-subtle table-first-last-cell-padding-reset"
                    data={regularPayment}
                    col={filteredCurrentRegularPaymentInstructionscol}
                />
            </div>
        );

        return paymentsHtml;
    }

    const currentRegularPaymentInstructionscol = [
        {
            title: "Payer",
            key: "Payer",            
            render: (data) => {
                if (
                    data === null ||
                    data === "" ||
                    data === PaymentPayer.NotSpecified
                ) {
                    return (
                        <AriaTooltip
                            cssWrapper="is-underlined-text no-border-radius"
                            buttonText={"No recorded Payee"}
                            showCloseButton={true}
                        >
                            We don't have a record of the payee for this transaction
                        </AriaTooltip>
                    );
                } else {
                    return PaymentPayerMapper[data];
                }
            },
        },
        {
            title: isNpr ? "Amount (Net)" : "Amount",
            tdCssWrapper: "cell-right",
            thCssWrapper: "cell-right",
            key: "Amount",
            render: (data) => {
                return MoneyDisplayHelper.FromatMoneyDisplay(
                    data,
                    CurrencyCode.GBP,
                    true,
                    2
                );
            },
        },
        {
            title: "Tax relief",
            tdCssWrapper: "cell-right",
            thCssWrapper: "cell-right",
            key: "Amount",
            render: (data, row) => {
                if (row.IsTaxRelief === false) {
                    return "N/A"
                } else {
                    return MoneyDisplayHelper.FromatMoneyDisplay(
                        data * 0.25,
                        CurrencyCode.GBP,
                        true,
                        2
                    );
                }
            },
        },
        {
            title: "Frequency",
            key: "Frequency",
        },
        {
            title: "Paid from",
            key: "PaidFrom",
        },
        {
            title: "Next Payment",
            key: "NextPaymentDate",
            render: (data) => {
                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
            },
        },
        {
            title: "Final Payment",
            key: "FinalPaymentDate",
            render: (data) => {
                if (data === null) {
                    return "Until Notified"
                }
                else {
                    return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");

                }
            },
        },
        {
            title: "Investment allocation",
            key: "Id",
            render: (data, row) => {
                return checkPermission(UserClaim.AdviserPortalDluOrdersCanView) && !row.IsFullCashAllocation ? (
                    <a
                        href={`/clients/orders/orders.aspx?claccountid=${props.headAccount?.HeadClAccountId}&SearchBatchType=Standing`}
                        className="hyperlink"
                    >
                        View
                    </a>
                ) : null;
            },
        },
        {
            title: "Indexation",
            key: "Indexation",
            render: (data) => {
                return data;
            },
        },
        {
            title: "",
            key: "Id",
            render: (data, row) => {
                return (
                    <button
                        className="select-toggle"
                        onClick={() => {
                            setLightBoxInfo({
                                isShow: true,
                                amount: row.Amount,
                                frequency: row.Frequency,
                                bankAccount: row.PaidFrom,
                                nextPaymentDate: row.NextPaymentDate,
                                cashEntryId: row.CashEntryId,
                            });
                        }}
                    >
                        Cancel
                    </button>
                );
            },
        },
    ];

    const filteredCurrentRegularPaymentInstructionscol = isNpr
        ? currentRegularPaymentInstructionscol
        : currentRegularPaymentInstructionscol.filter((col) => col.title !== "Tax relief");

    const currentSinglePaymentInstructionscol = [
        {
            title: "Payer",
            key: "Payer",
            render: (data) => {
                if (
                    data === null ||
                    data === "" ||
                    data === PaymentPayer.NotSpecified
                ) {
                    return (
                        <AriaTooltip
                            cssWrapper="is-underlined-text no-border-radius"
                            buttonText={"No recorded Payee"}
                            showCloseButton={true}
                        >
                            We don’t have a record of the payee for this
                            transaction
                        </AriaTooltip>
                    );
                } else {
                    return PaymentPayerMapper[data];
                }
            },
        },
        {
            title: isNpr ? "Amount (Net)" : "Amount",
            key: "Amount",
            render: (data) => {
                return MoneyDisplayHelper.FromatMoneyDisplay(
                    data,
                    CurrencyCode.GBP,
                    true,
                    2
                );
            },
        },
        {
            title: "Tax relief",
            key: "Amount",
            render: (data, row) => {
                if (row.IsTaxRelief === false) {
                    return "N/A"
                } else {
                    return MoneyDisplayHelper.FromatMoneyDisplay(
                        data * 0.25,
                        CurrencyCode.GBP,
                        true,
                        2
                    );
                }
            },
        },
        {
            title: "Frequency",
            key: "Frequency",
        },
        {
            title: "Paid from",
            key: "PaidFrom",
        },
    ];

    const filteredCurrentSinglePaymentInstructionscol = isNpr
        ? currentSinglePaymentInstructionscol
        : currentSinglePaymentInstructionscol.filter((col) => col.title !== "Tax relief");

    const expectedTransferscol = [
        {
            title: "Ceding provider",
            key: "Provider",
        },
        {
            title: "Type",
            key: "ArrangementType",
            render: (data) => {
                return data;
            }
        },
        {
            title: "Type",
            key: "TransferType",
            render: (data) => {
                return TransferTypeMapper[data];
            }
        },
        {
            title: "Status",
            key: "Status",
            render: (data) => {
                return TransferStatusMapper[data];
            },
        },
        {
            title: isNpr ? "Value" : "Amount",
            key: "Amount",
            render: (data) => {
                if (data === null) {
                    return "No amount recorded";
                } else {
                    return MoneyDisplayHelper.FromatMoneyDisplay(
                        data,
                        CurrencyCode.GBP,
                        true,
                        2
                    );
                }
            },
        },
    ];

    const filteredExpectedTransferscol = isNpr
        ? expectedTransferscol.filter((col) => col.key !== "TransferType")
        : expectedTransferscol.filter((col) => col.key !== "ArrangementType");

    useEffect(() => {
        ProductOverviewPaymentsInAction.getPendingProductPaymentsIn(props.subAccountHierarchyId, (data) => {
            const splitDatum = splitData(data);
            setSinglePayment(splitDatum.single);
            setRegularPayment(splitDatum.regular);
        });

        if (SubAccountTypeHelper.isOnPlatformPension(props.SubaccountType)) {
            ProductOverviewPaymentsInAction.getMPAAInfo(props.subAccountHierarchyId, (data) => {
                setMPAAInfo(data)
            });

            ProductOverviewPaymentsInAction.getIndexation(props.subAccountHierarchyId, (data) => {
                setIndexationState(data);
            });
        }
    }, [props.subAccountHierarchyId]);

    return (
        <>
            <div className="ad d1">
                <h1 className="sr-only">Payment in</h1>
                <h2 className="mb-22">Active instructions</h2>

                {!SubAccountTypeHelper.isBond(props.SubaccountType) && (
                    <div className="d-flex f-direction-column">
                        <div className="row mb-5">
                            <div className="col-auto col-middle">
                                <h3 className="mb-0">Current regular payment instructions</h3>
                            </div>
                            {regularPayment?.length > 0 &&
                                checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                                    <div className="col-fluid col-middle">
                                        <button
                                            type="button"
                                            title="Edit"
                                            className="edit-circle-icon-button label-sr-only"
                                            onClick={() => {
                                                Action.getRegularPaymentCashEntry(
                                                    props.subAccountHierarchyId,
                                                    CashPaymentTypeQuery.Deposit,
                                                    CashPaymentFrequencyQuery.Regular,
                                                    (result) => {
                                                        const clientRegularPayment = result.filter(
                                                            (cashEntry) =>
                                                                cashEntry.InstructionType == InstructionType.Standing &&
                                                                cashEntry.Status == PaymentStatus.Authorised
                                                        );
                                                        if (clientRegularPayment.length > 1) {
                                                            setSelectClientRegular(clientRegularPayment);
                                                        } else {
                                                            window.location.assign(
                                                                editRegularLink(clientRegularPayment[0]?.BatchId)
                                                            );
                                                        }
                                                    }
                                                );
                                            }}
                                        >
                                            <span className="icon" aria-hidden="true"></span>
                                            <span className="text">Edit current regular payment instructions</span>
                                        </button>

                                        {/*<button type="button" className="edit-circle-icon-button"><span className="icon"></span><span className="sr-only">Edit Current regular payment instructions</span></button>*/}
                                    </div>
                                )}
                        </div>
                        {regularPayment?.length > 0 ? renderRegularPayments() : (
                            <div className="panel-subtle mb-40">
                                <span>No regular payment(s) currently set up for this client</span>
                            </div>
                        )}
                    </div>
                )}
                <div className="row wide-gutter">
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            <h3 className="mb-5">Expected single payment(s)</h3>
                            <div className="panel-subtle mb-20 f-grow-1">
                                <div>
                                    {singlePayment?.length > 0 ? (
                                        <Table
                                            cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                            data={singlePayment}
                                            col={filteredCurrentSinglePaymentInstructionscol}
                                        />
                                    ) : (
                                        <p className="mb-10">
                                            No single payment(s) currently set up for this client
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-fluid col-equalise">
                        <div className="d-flex f-direction-column">
                            {isNpr ? <h3 className="mb-5">Expected transfers</h3> : <h3 className="mb-5">Transfers</h3>}
                            <div className="panel-subtle mb-20 f-grow-1">
                                <div>
                                    {props.activeTransferIn?.length > 0 ? (
                                        <Table
                                            cssWrapper="table-subtle table-first-last-cell-padding-reset mb-10"
                                            data={props.activeTransferIn}
                                            col={filteredExpectedTransferscol}
                                        />
                                    ) : (
                                        <p className="mb-10">No transfer(s) currently set up for this client</p>
                                    )}

                                    {props.activeTransferIn?.length > 0 &&
                                    checkPermission(UserClaim.AdviserPortalDluReregistrationTransfersCanView) ? (
                                        <a
                                            href={`/clients/tracking/reregistration-transfers.aspx?claccountid=${props.headAccount?.HeadClAccountId}&txtStatus=Open`}
                                            className="hyperlink"
                                        >
                                            {props.activeTransferIn?.length} pending transfer
                                        </a>
                                    ) : (
                                        <span>{props.activeTransferIn?.length} pending transfer</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {SubAccountTypeHelper.isOnPlatformPension(props.SubaccountType) &&
                    <div className="row wide-gutter">
                        <div className="col-6 col-equalise">
                            <div className="d-flex f-direction-column">
                                <h3 className="mb-5">Annual Allowance {" "}
                                <AriaTooltip cssWrapper="is-info-icon" showCloseButton={true}>
                                Your client's allowance may differ if they are subject to tapering
                                </AriaTooltip>
                                </h3>
                                <div className="panel-subtle pt-20 pb-10 mb-20 f-grow-1">
                                    <div>
                                        {mpaaInfo && mpaaInfo.CurrentTaxYear && isNumber(mpaaInfo.RemainingAllowance) &&

                                            <div><span>Tax year {mpaaInfo.CurrentTaxYear}</span>
                                                <table className="table-subtle table-first-last-cell-padding-reset">
                                                    <tbody>
                                                    <tr>
                                                        <td>Remaining</td>
                                                        <td>{mpaaInfo.RemainingAllowance}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                        {mpaaInfo && mpaaInfo.MpaaValues?.length > 0 && (
                                            <div className="mt-10">
                                                <a className="hyperlink" onClick={() => { setShowMPAAValue(!showMPAAValue) }}>View historic tax year information</a>
                                            </div>)}
                                        {mpaaInfo && mpaaInfo.MpaaValues?.length > 0 ? showMPAAValue &&
                                            (<Table
                                                    cssWrapper="table-subtle table-first-last-cell-padding-reset"
                                                    data={mpaaInfo.MpaaValues}
                                                    col={[
                                                        {
                                                            title: "Tax Year",
                                                            key: "TaxYear"
                                                        },
                                                        {
                                                            title: "Allowance Value",
                                                            key: "AllowanceValue",
                                                            render: (data) => {
                                                                return MoneyDisplayHelper.FromatMoneyDisplay(
                                                                    data,
                                                                    CurrencyCode.GBP,
                                                                    true,
                                                                    2
                                                                );
                                                            },
                                                        }
                                                    ]}
                                                />
                                            ) : (
                                            <p className="mb-10">
                                                There is no historic tax year information
                                            </p>)
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                <hr />
                {lightBoxInfo.isShow && (
                    <Lightbox
                        show={lightBoxInfo.isShow}
                        title={"Are you sure you want to cancel all future regular payments?"}
                        contentAfterTitle={null}
                        onClose={() => {
                            setLightBoxInfo({
                                isShow: false,
                                amount: null,
                                frequency: null,
                                bankAccount: null,
                                nextPaymentDate: null,
                                cashEntryId: null,
                            });
                        }}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted">
                            <tbody>
                            <tr>
                                <th scope="row">Amount</th>
                                <td className="cell-right">
                                    {MoneyDisplayHelper.FromatMoneyDisplay(
                                        lightBoxInfo.amount,
                                        CurrencyCode.GBP,
                                        true,
                                        2
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">Frequency</th>
                                <td className="cell-right">{lightBoxInfo.frequency}</td>
                            </tr>
                            <tr>
                                <th scope="row">Bank account</th>
                                <td className="cell-right">{lightBoxInfo.bankAccount}</td>
                            </tr>
                            <tr>
                                <th scope="row">Next payment</th>
                                <td className="cell-right">{lightBoxInfo.nextPaymentDate}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div className="row row-center">
                            <div className="col-auto">
                                <button
                                    className="btn primary"
                                    onClick={() => {
                                        ProductOverviewPaymentsInAction.cancelRegularPaymentsIn(
                                            lightBoxInfo.cashEntryId,
                                            props.subAccountHierarchyId,
                                            (data) => {
                                                const splitDatum = splitData(data);
                                                setRegularPayment(splitDatum.regular);
                                                setLightBoxInfo({
                                                    isShow: false,
                                                    amount: null,
                                                    frequency: null,
                                                    bankAccount: null,
                                                    nextPaymentDate: null,
                                                    cashEntryId: null,
                                                });
                                            }
                                        );
                                    }}
                                >
                                    Yes
                                </button>
                            </div>
                            <div className="col-auto">
                                <button
                                    className="btn secondary"
                                    onClick={() => {
                                        setLightBoxInfo({
                                            isShow: false,
                                            amount: null,
                                            frequency: null,
                                            bankAccount: null,
                                            nextPaymentDate: null,
                                            cashEntryId: null,
                                        });
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Lightbox>
                )}
            </div>
            <Permission userClaim={UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite}>
                <SelectRegularPaymentPop
                    clientRegularPayment={selectClientRegular}
                    onClose={() => {
                        setSelectClientRegular([]);
                    }}
                    onSelect={(id) => window.location.assign(editRegularLink(id))}
                />
            </Permission>
        </>
    );
};
